<template>
  <dialog-reset
    title="出入库记录详情"
    :visible.sync="visible"
    width="900px"
    top="5vh"
    :zoomShow="false"
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
  >
    <div class="detail-container" v-loading="loading">
      <!-- 基本信息 -->
      <div class="card">
        <div class="card-title">基本信息</div>
        <div class="card-grid">
          <div class="item">
            <div class="label">流水号</div>
            <div class="value">{{ detail.flowNo || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">操作类型</div>
            <div class="value">
              <el-tag :type="detail.recordType === 'IN' ? 'success' : 'warning'" size="mini">
                {{ detail.recordType === 'IN' ? '入库' : '出库' }}
              </el-tag>
            </div>
          </div>
          <div class="item">
            <div class="label">操作时间</div>
            <div class="value">{{ detail.operationTime || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">操作人</div>
            <div class="value">{{ detail.operatorName || '-' }}</div>
          </div>
        </div>
      </div>

      <!-- 配件信息 -->
      <div class="card">
        <div class="card-title">配件信息</div>
        <div class="card-grid">
          <div class="item">
            <div class="label">配件编码</div>
            <div class="value">{{ detail.partCode || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">配件名称</div>
            <div class="value">{{ detail.partName || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">规格型号</div>
            <div class="value">{{ detail.specification || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">计量单位</div>
            <div class="value">{{ detail.unit || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">批次/序列号</div>
            <div class="value">{{ detail.batchNo || '-' }}</div>
          </div>
          <div class="item">
            <div class="label">仓库 / 库位</div>
            <div class="value">{{ formatWarehouse(detail) }}</div>
          </div>
        </div>
      </div>

      <!-- 库存变动详情 -->
      <div class="card">
        <div class="card-title">库存变动详情</div>
        <div class="card-grid">
          <div class="item">
            <div class="label">操作前库存</div>
            <div class="value">{{ toDisplay(detail.beforeStock) }}</div>
          </div>
          <div class="item">
            <div class="label">变动数量</div>
            <div class="value">
              <span :class="detail.recordType === 'IN' ? 'text-success' : 'text-warning'">
                {{ formatChange(detail.changeQty) }}
              </span>
            </div>
          </div>
          <div class="item">
            <div class="label">操作后库存</div>
            <div class="value">{{ toDisplay(detail.afterStock) }}</div>
          </div>
        </div>
      </div>

      <!-- 业务关联信息 -->
      <div class="card">
        <div class="card-title">业务关联信息</div>
        <div class="card-grid">
          <div class="item">
            <div class="label">关联单号</div>
            <div class="value">{{ detail.bizOrderNo || '-' }}</div>
          </div>
        </div>
      </div>

      <!-- 备注说明 -->
      <div class="card">
        <div class="card-title">备注与说明</div>
        <div class="remark">{{ detail.remark || '无' }}</div>
      </div>
    </div>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">关闭</el-button>
    </span>
  </dialog-reset>
</template>

<script>
export default {
  name: 'RecordDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatWarehouse (detail) {
      const store = detail.warehouseName || detail.stockName
      const loc = detail.locationName || detail.locationCode
      if (store && loc) return `${store} / ${loc}`
      if (store) return store
      if (loc) return loc
      return '-'
    },
    toDisplay (val) {
      if (val === 0) return 0
      return val || val === 0 ? val : '-'
    },
    formatChange (val) {
      if (val === null || val === undefined || val === '') return '-'
      if (Number(val) > 0) return `+${val}`
      return `${val}`
    }
  }
}
</script>

<style scoped lang="scss">
.detail-container {
  padding: 4px 0 8px;
}
.card {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.card-title {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 14px;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}
.item .label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}
.item .value {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}
.remark {
  font-size: 14px;
  color: #333;
  min-height: 24px;
}
.text-success {
  color: #67c23a;
}
.text-warning {
  color: #e6a23c;
}
</style>




